









































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { getTaxRoundTypes, getTaxRoundTypeName } from '@/enums/taxRoundTypes';
import { getTaxTypes, getTaxTypeName } from '@/enums/taxTypes';
import { CreditcardAPIKeyRequest, CreditcardSettingRequest } from '@/models/creditcardSettingRequest';
import { CreditcardSettingResponse } from '@/models/creditcardSettingResponse';
import Axios from 'axios';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { ElForm } from 'node_modules/element-ui/types/form';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({})
export default class BillSettings extends AvaivaledVue {
  public getTaxRoundTypes = getTaxRoundTypes;
  public getTaxRoundTypeName = getTaxRoundTypeName;
  public getTaxTypes = getTaxTypes;
  public getTaxTypeName = getTaxTypeName;

  private isLoading: boolean = true;
  private creditcardEnabled: boolean = false;
  private storeId: string = '';
  private tokenKey: string = '';
  private creditcardAPIKey: string = '';
  private creditcardSettlementHour: number = 0;

  private deleteFormRule = {
    checkInput: [
      { required: true, message: '「はい」と入力してください' },
      { validator: this.validateYes, trigger: 'blur' },
    ],
  };

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPayRoute() {
    return this.collectionAgency === CollectionAgencyTypes.PayRoute;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  get isUnivaPay() {
    return this.collectionAgency === CollectionAgencyTypes.UnivaPay;
  }

  private validateYes(rule: any, value: string, callback: any) {
    if (value.replace(/\s+/g, '') === 'はい'.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('「はい」と入力してください'));
    }
  }

  private async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }

    try {
      const res = await Axios.get<CreditcardSettingResponse>('/api/bill-settings/creditcard');
      this.creditcardEnabled = res.data.enabled;
      this.tokenKey = res.data.tokenKey;
      this.creditcardSettlementHour = res.data.creditcardSettlementHour;
    } catch (error) {
      this.$router.push('/');
    }

    this.isLoading = false;
  }

  private async mounted() {
    while (!(this as any).creditcardTokenUrl) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    const creditcardTokenUrl = (this as any).creditcardTokenUrl;
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', creditcardTokenUrl);
    document.head.appendChild(recaptchaScript);
  }

  private deactivated() {
    this.$destroy();
  }

  private async onRegisterAPIKey() {
    if (this.isPayRoute) {
    try {
      await this.getToken('4111111111111111', '99', '12', '123', 'TEST');
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード設定登録',
        message: 'トークン取得キーが間違っています。',
        position: 'bottom-right'
      });
      return;
    }
    }

    try {
      await Axios.put('/api/bill-settings/creditcard-apikey', {
        storeId: this.storeId,
        tokenKey: this.tokenKey,
        apiKey: this.creditcardAPIKey,
      } as CreditcardAPIKeyRequest);
      this.creditcardEnabled = true;
      this.$notify.success({
        title: 'クレジットカード設定登録',
        message: 'クレジットカード決済APIを登録しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード設定登録',
        message: (error.response && error.response.data) || 'クレジットカード決済APIの登録が失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private async onRegisterSetting() {
    try {
      await Axios.put('/api/bill-settings/creditcard', {
        creditcardSettlementHour: this.creditcardSettlementHour,
      } as CreditcardSettingRequest);
      this.$notify.success({
        title: 'クレジットカード設定登録',
        message: 'クレジットカード設定を登録しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード設定登録',
        message: 'クレジットカード設定の登録が失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private async onDelete() {
    try {
      const form = {
        checkInput: '',
      };
      await (this.$refs.settingDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    try {
      await Axios.delete('/api/bill-settings/creditcard-apikey');
      this.creditcardEnabled = false;
      this.storeId = '';
      this.tokenKey = '';
      this.creditcardAPIKey = '';
      this.$notify.success({
        title: 'クレジットカード決済設定削除',
        message: 'クレジットカード決済設定を削除しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'クレジットカード決済設定削除',
        message: 'クレジットカード決済設定の削除が失敗しました。',
        position: 'bottom-right'
      });
    }
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.settingDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async getToken(
    cardno: string,
    expireYear: string,
    expireMonth: string,
    securitycode: string,
    holdername: string
  ): Promise<string | null> {
    return await new Promise<string | null>((resolve, reject) => {
      (window as any).Multipayment.init(this.tokenKey);

      (window as any).Multipayment.getToken(
        {
            cardno,
            expire: expireYear + expireMonth,
            securitycode,
            holdername,
            tokennumber: 1
        }, (result: any) => {
          switch (result.resultCode) {
            case '551':
            case '552':
              // トークン発行失敗（APIキー異常）
              reject(result.resultCode);
              break;
            case '000':
              // トークン発行成功
              resolve(result.tokenObject.token[0]);
              break;
            default:
              // トークン発行失敗（APIキー正常）
              resolve(null);
              break;
          }
        }
      );
    });
  }
}
